import UpcomingEvent from './UpcomingEvent';

export default UpcomingEvent;
